const mapToServerObject = hub => {
    const outlets = hub.outlets.map(o => o.id);

    return Object.assign(_.pick(hub, ['name', 'id', 'settings']), {
        outlets,
    });
};

export default {
    namespaced: true,
    state: {
        hub: {
            id: null,
            name: null,
            outlets: [],
            settings: [],
        },
        assignedOutletList: [],
    },
    getters: {
        hub: state => state.hub,

        outletTaken: state => set_id => {
            return state.assignedOutletList
                .filter(o => o.central_setting_set_id != set_id)
                .map(o => o.outlet_id);
        },

        groupedSettings: state => {
            return _.groupBy(
                state.settingSet.central_settings,
                cs => cs.group.id,
            );
        },
    },
    mutations: {
        setSettingSet(state, set) {
            state.hub = set;
        },

        setSettingValue(state, { index, value }) {
            state.settingSet.central_settings[index].value = value;
        },

        setSettingSetAttibute(state, { attr, value }) {
            state.settingSet[attr] = value;
        },

        setOutlets(state, outlets) {
            state.settingSet.outlets = outlets;
        },

        setAssignedOutletList(state, assignedOutlets) {
            state.assignedOutletList = assignedOutlets;
        },
    },
    actions: {
        createSettingSet(context, set) {
            const route = Laroute.route(
                'franchise.setting.hub_settings.create',
            );

            return axios.post(route, set);
        },

        getHubSettingSet(context, id) {
            const url = Laroute.route('franchise.hub_settings.show', { id });

            return axios
                .get(url)
                .then(res => {
                    return res;
                })
                .catch(err => {
                    throw err;
                });
        },

        getGlobalHubSettingSet(context) {
            const url = Laroute.route('franchise.hub_settings.show.global');

            return axios
                .get(url)
                .then(res => {
                    return res;
                })
                .catch(err => {
                    throw err;
                });
        },

        getHubSettingValue(context, params) {
            const url = Laroute.route('franchise.hub_settings.value', {
                outlet_id: params.outlet_id,
                id: params.id,
            });

            return axios
                .get(url)
                .then(res => {
                    return res;
                })
                .catch(err => {
                    throw err;
                });
        },

        setHubSettingSet({ commit }, set) {
            commit('setSettingSet', set);
        },

        updateHubSetting(context, hub) {
            const url = Laroute.route('franchise.hub_settings.update', {
                outlet_id: hub.outlet_id,
                id: hub.hub.id,
            });

            return axios.put(url, hub);
        },

        updateGlobalHubSetting(context, configs) {
            const url = Laroute.route('franchise.hub_settings.update.global');

            return axios.put(url, configs);
        },

        createHubSetting(context, hub) {
            const url = Laroute.route('franchise.hub_settings.store');

            return axios.post(url, mapToServerObject(hub));
        },

        setOutlets({ commit }, outlets) {
            commit('setOutlets', outlets);
        },

        setSettingSetAttibute({ commit }, { attr, value }) {
            commit('setSettingSetAttibute', { attr, value });
        },

        async getAssignedOutletList({ commit }) {
            const url = Laroute.route(
                'franchise.setting.hub_settings.set.assigned_outlets',
            );

            let { data } = await axios.get(url);
            commit('setAssignedOutletList', data);
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/hub-settings.js